import { Dialog, DialogContent, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { forwardRef } from 'react';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PricingBanner } from './PricingBanner';
import { useAppDispatch, useAppSelector } from '../hooks/useAppStore';
import { getIsOpenPricingDialog } from '../store/common/selectors';
import { commonActions } from '../store/common/slice';
import MotivationIllustration from './MotivationIllustration';

// Transition component to apply the slide animation
const Transition = forwardRef((
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) => <Slide direction="down" ref={ref} {...props} />);

const PricingDialog = () => {
  const isOpenPricingDialog = useAppSelector(getIsOpenPricingDialog);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('pricing');

  const onClose = () => {
    dispatch(commonActions.setIsOpenPricingDialog(false));
  };

  const goToPricing = () => {
    navigate('/onboarding/pricing?channel=app');
  };

  return (
    <Dialog
      sx={{
        zIndex: 999999,
      }}
      open={isOpenPricingDialog}
      onClose={onClose}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          position: 'fixed',
          top: 0,
          m: 0,
          borderRadius: 0,
          maxWidth: '100%',
          width: '100%',
          height: 'auto',
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <PricingBanner
          onClose={onClose}
          title={t('upgradeToUnlock')}
          description={t('youCurrentPlan')}
          img={(
            <MotivationIllustration
              sx={{
                p: 3,
                width: 360,
                margin: { xs: 'auto', md: 'inherit' },
              }}
            />
          )}
          action={<Button onClick={goToPricing} variant="contained">{t('upgradePlan')}</Button>}
        />
      </DialogContent>
    </Dialog>
  );
};

export { PricingDialog };
